export default __webpack_public_path__ + "static/media/05_dialog.5d3f6e72.svg";